// Module
var code = "<section class=\"about-content\"> <div data-about-content-first class=\"about-content-first\"> </div> <div data-about-content-second class=\"about-content-second page-detail-wrapper\"> </div> </section>";
// Exports
export default code;